import { Skeleton } from "@dmm-com/rocket-web-ui-library";
import * as Styled from "./style";

export const ProductSkeleton = () => {
  return (
    <Styled.DivProductSkeletonRoot>
      <Skeleton type="square" width="80%" height={80} margin="0 0 16px 0" borderRadius={8} />

      <Skeleton type="square" width="10%" height={24} margin="0 0 16px 0" borderRadius={8} />

      <Skeleton type="square" width="10%" height={24} margin="0 0 40px 0" borderRadius={8} />

      <Skeleton type="square" width="10%" height={24} margin="0 0 8px 0" borderRadius={8} />

      <Skeleton type="square" width="100%" height={80} margin="0 0 24px 0" borderRadius={8} />

      <Skeleton type="square" width="10%" height={24} margin="0 0 8px 0" borderRadius={8} />

      <Skeleton type="square" width="100%" height={80} borderRadius={8} />
    </Styled.DivProductSkeletonRoot>
  );
};
